module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/60.df6ddca0.png";